import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './teStyle.css';
import config from '../../config.json';
import TimeEntryLabel from './TimeEntryLabel';

const apiUrl = config.apiUrl;

const TimeEntryDelete = () => {
    const [timeEntryDetails, setTimeEntryDetails] = useState({
        TransactionDate: '',
        Employee: [],
        StartDate: '',
        EndDate: '',
        EntryTypeID: '',
        Remarks: '',
        Status: '',
    });

    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isDisable, setIsDisable] = useState(false);
    const navigate = useNavigate();
    const { timeEntryId } = useParams();
    const roles = JSON.parse(localStorage.getItem('Roles'));

    const userAccess = {
        hasView: roles?.includes('View') || false,
        hasAdmin: roles?.includes('Admin') || false,
        hasApprover: roles?.includes('Approver') || false,
        hasStandard: roles?.includes('Standard') || false,
    };

    const { hasView, hasAdmin, hasStandard, hasApprover } = userAccess;

    useEffect(() => {
        const fetchTimeEntryData = async () => {
            setIsDisable(true);
            const token = localStorage.getItem('token');
            try {
                const response = await fetch(`${apiUrl}/TimeEntry/${timeEntryId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    setErrorMessage('Failed to fetch time entry data');
                    setSuccessMessage('');
                    return;
                }
                const data = await response.json();
                setTimeEntryDetails({
                    TransactionDate: data.Details.TransactionDate,
                    Employee: data.Details.Employee,
                    StartDate: data.Details.StartDate,
                    EndDate: data.Details.EndDate,
                    EntryTypeID: data.Details.EntryTypeID,
                    Remarks: data.Details.Remarks,
                    Status: data.Details.Status,
                });
                setIsDisable(false);
            } catch (error) {
                setErrorMessage('Error fetching time entry data');
                setSuccessMessage('');
                setIsDisable(false);
            }
        };

        fetchTimeEntryData();
    }, []);

    const handleDelete = async (e) => {
        e.preventDefault();

        // Disable the button when the API process starts
        setIsDisable(true);

        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${apiUrl}/TimeEntry/Delete/${timeEntryId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.ok) {
                const data = await response.json();
                setErrorMessage('');
                setSuccessMessage(data.Message);
                setIsDisable(false);
                navigate('/timeentry-list');
            }
        } catch (error) {
            setErrorMessage('Error deleting time entry');
            setSuccessMessage('');
            setIsDisable(false);
        }
    };

    const {
        TransactionDate,
        Employee,
        StartDate,
        EndDate,
        EntryTypeID,
        Remarks,
        Status,
    } = timeEntryDetails;

    return (
        <div>
            {(userAccess.hasAdmin || userAccess.hasStandard) ? (
                <>
                    <h3>Delete Time Entry</h3>
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    <form onSubmit={handleDelete}>
                        <div className="row mt-4">
                            <TimeEntryLabel label="Transaction Date" value={TransactionDate} />
                            <TimeEntryLabel label="Employee" value={Employee.Name} />
                            <TimeEntryLabel label="Time In" value={StartDate} />
                            <TimeEntryLabel label="Time Out" value={EndDate} />
                            <TimeEntryLabel label="Entry Type" value={EntryTypeID} />
                            <TimeEntryLabel label="Remarks" value={Remarks} />
                            <TimeEntryLabel label="Status" value={Status} />
                        </div>

                        <div className="mb-2">
                            <Link to="/leave-list" className="btn btn-secondary me-2">Back</Link>
                            {(userAccess.hasStandard || userAccess.hasAdmin) && (
                                <button
                                    type="submit"
                                    className="btn btn-danger"
                                    disabled={isDisable}
                                >
                                    Delete
                                </button>
                            )}
                        </div>
                    </form>
                </>
            ) : (
                <div>
                    <h3>No access!</h3>
                    <button className="btn btn-primary" onClick={() => navigate(-1)}>
                        Go Back
                    </button>
                </div>
            )}
        </div>
    );
};

export default TimeEntryDelete;
